/* eslint-disable react/jsx-pascal-case */
import { US, CA } from 'country-flag-icons/react/3x2';

interface BayCountryIconProps {
	country: string;
	height?: number;
	[key: string]: any;
}

const BayCountryIcon = (props: BayCountryIconProps) => {
	const { country, height, ...rest } = props;

	switch (country) {
	case 'US':
		return (
			<US
				style={{ height: `${height || 16}px` }}
				title="United States"
				{...rest}
			/>
		);
	case 'CA':
		return (
			<CA style={{ height: `${height || 16}px` }} title="Canada" {...rest} />
		);
	default:
		return null;
	}
};

export default BayCountryIcon;
